


















import Vue from 'vue';
import PoseIcon from '@/components/PoseIcon.vue';

export default Vue.extend({
  name: 'PracticeBubble',
  components: {
    PoseIcon,
  },
  props: {
    alt: String,
    coverPoseName: String,
    coverPoseSide: String,
    duration: Number,
    name: String,
    practiceStyle: String,
  },
  filters: {
    minutes(value: number) {
      if (!value) {
        return '';
      }

      return Math.ceil(value / 60);
    },
  },
});
